import type { BaseLayerRaw } from '@tsyl/karonte/lib/types/layers'

import type { OrganizationLayersTOC } from '@/types/OrganizationLayers'

const GROUP_ORDER = [
  'riskLayers',
  'reference',
  'burnedAreas:viirs'
  // ...otros nombres de grupo en el orden que quieras...
]

export function mergeTocs(...tocs: OrganizationLayersTOC[][]) {
  const tocMap = new Map<string, { name: string; layers: BaseLayerRaw[] }>()
  const encountered: string[] = []

  for (const toc of tocs) {
    for (const group of toc) {
      if (!tocMap.has(group.name)) {
        tocMap.set(group.name, { name: group.name, layers: [] })
        encountered.push(group.name)
      }
      const existingLayers = tocMap.get(group.name)!.layers
      for (const layer of group.layers) {
        if (!existingLayers.some((l) => l.id === layer.id)) {
          existingLayers.push(layer)
        }
      }
    }
  }

  // Sort by GROUP_ORDER, then by encounter order
  const result = Array.from(tocMap.values()).sort((a, b) => {
    const idxA = GROUP_ORDER.indexOf(a.name)
    const idxB = GROUP_ORDER.indexOf(b.name)
    if (idxA === -1 && idxB === -1) {
      // Neither in GROUP_ORDER: preserve encounter order
      return encountered.indexOf(a.name) - encountered.indexOf(b.name)
    }
    if (idxA === -1) return 1 // a goes after b
    if (idxB === -1) return -1 // b goes after a
    return idxA - idxB
  })

  return result
}
